import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const DropdownButton = ({ options, title, className }) => (
  <div className="dropdown">
    <button
      className={`btn dropdown-toggle ${className}`}
      type="button"
      id="dropdownMenuButton"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      {title}
    </button>
    <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
      {options.map(option => (
        <Link className="dropdown-item" to={option.path} onClick={option.onClick} key={option.text}>
          {option.text}
        </Link>
      ))}
    </div>
  </div>
);

DropdownButton.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      path: PropTypes.string,
      onClick: PropTypes.func,
    }),
  ).isRequired,
};

DropdownButton.defaultProps = {
  className: 'btn-primary',
};

export default DropdownButton;



// WEBPACK FOOTER //
// ./src/components/DropdownButton/index.js